import React from 'react';

type Props = {
  ingredients: string;
};

const BoldPrimaryIngredients: React.FC<Props> = ({ ingredients }) => {
  // Only apply bolding when there are sub-ingredients, at least one ().
  if (!/\([^()]*\)/.test(ingredients)) {
    return ingredients;
  }

  const parts = ingredients.split(/(\([^()]*\)\.?)/);

  return parts.map((part) => {
    if (part.charAt(0) === '(') {
      return part;
    }

    return <strong>{part}</strong>;
  });
};

export default BoldPrimaryIngredients;
